import api from '../../../../../configurations/service';
import * as types from './mutation-types';
import { orderTypeEnum } from '../../Shared/enums/orderTypeEnum';

export const setProductCollection = async (context, params) => {
  const body = {
    search: params?.search ?? '',
    maxResults: params?.results ?? 30,
    orderType: params?.orderType ?? orderTypeEnum.SALE,
  };
  const { data } = await api().post('inventory.search-products-for-documents', body);
  const products = Array.isArray(data.data) ? data.data : [];
  context.commit(types.SET_PRODUCT_COLLECTION, products);
};

export const resetProductCollection = (context) => {
  context.commit(types.SET_PRODUCT_COLLECTION, []);
};

export const setProductInventory = (context, product) => {
  context.commit(types.SET_PRODUCT_INVENTORY, product);
};
